import { render } from "./terms.vue?vue&type=template&id=471b8319&scoped=true"
import script from "./terms.vue?vue&type=script&lang=js"
export * from "./terms.vue?vue&type=script&lang=js"

import "./terms.vue?vue&type=style&index=0&id=471b8319&scoped=true&lang=css"

import exportComponent from "D:\\work\\hw-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-471b8319"]])

export default __exports__